var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column",attrs:{"height":"100%"}},[_c('v-card-title',[_vm._t("title")],2),_c('v-card-text',{staticClass:"grow"},[_vm._t("text")],2),_c('v-card-actions',[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }